var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpiter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397,377.45c0,72.06-23.77,142.98-71.3,212.75-11.5,16.88-24.55,33.36-39.11,49.45h253v-269.11h66.7v269.11h233.45v67.84h-233.45v269.09h-66.7v-269.09H203.8l-20.7-58.66c30.66-23.75,59.8-55.95,87.41-96.59,39.86-58.27,59.8-116.53,59.8-174.8,0-48.3-12.27-95.06-36.8-140.3s-53.28-84.72-86.25-118.45c-9.2-8.44-17.25-15.72-24.16-21.86l41.41-51.75c9.19,7.67,18.78,16.48,28.75,26.45,26.83,26.84,50.59,55.97,71.3,87.41,48.3,72.06,72.45,144.91,72.45,218.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpiter);
export default __webpack_public_path__ + "static/media/Júpiter.15872a82173b035a976e6bf69e490c68.svg";
export { ForwardRef as ReactComponent };